import { render } from "./Given648.vue?vue&type=template&id=c526a0a2&scoped=true"
import script from "./Given648.vue?vue&type=script&lang=js"
export * from "./Given648.vue?vue&type=script&lang=js"

import "../../styles/removeVantcell.css?vue&type=style&index=0&id=c526a0a2&scoped=true&lang=css"
import "./Given648.vue?vue&type=style&index=1&id=c526a0a2&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c526a0a2"]])

export default __exports__